import React from 'react';
import createReactClass from 'create-react-class';
import CurrentStatusWidget from './CurrentStatusWidget';
import NotificationWidget from './NotificationWidget';
import TodoWidget from './TodoWidget';
import SparksChart from '../common/Diagrams/SparksChart';
import request from '../../helpers/request';
import dashboardConfig from './config/dashboardConfig';
import NeedsClaim from '../common/NeedsClaim';
import setViewTitle from '../../helpers/setViewTitle';


var Dashboard = createReactClass({

  getInitialState() {
    return {
      stockvalue: {
        storageLocations: [],
        entries: [],
        totalStockValue: 0
      },
      purchases: {
        months:[]
      }
    };
  },

  componentWillMount() {
    setViewTitle('Startseite');
  },

  componentDidMount() {
    request.get({
      url: dashboardConfig.apiUrl + 'stockvalue',
      success: stockvalue => {
        if (this.isMounted()) {
          this.setState({
            stockvalue
          });
        }
      }
    });

    request.get({
      url: dashboardConfig.apiUrl + 'purchases',
      success: purchases => {
        if (this.isMounted()) {
          this.setState({
            purchases
          });
        }
      }
    });
  },

  render() {
    var getSum = (months, getValue) => {
      var sum = months.reduce((prevValue, month) => prevValue + getValue(month), 0);
      return sum;
    };

    const openOrders = getSum(this.state.purchases.months, month => month.ordersOrdered - month.ordersClosed);

    return (
            <div>
                <div className="row">
                    <div className="col-xs-12 col-sm-7 col-md-7 col-lg-4">
                        <h1 className="page-title txt-color-blueDark"> Willkommen im Lagerpark</h1>
                    </div>
                    <div className="col-xs-12 col-sm-5 col-md-5 col-lg-8">
                        <ul id="sparks">
                          <NeedsClaim claim="dashboard:financial">
                            <SparksChart title="Aktueller Lagerwert" summary={`€${this.state.stockvalue.totalStockValue}`} colorClassName="txt-color-blue" showOnlyTitle={true} values="1300, 1877, 2500, 2577, 2000, 2100, 3000, 2700, 3631, 2471, 2700, 3631, 2471" />
                          </NeedsClaim>
                          <SparksChart title="Offene Bestellungen" summary={openOrders} colorClassName="txt-color-purple" showOnlyTitle={true} values="110,150,300,130,400,240,220,310,220,300, 270, 216" />
                        </ul>
                    </div>
                </div>
                <section>
                  <NeedsClaim claim="dashboard:financial">
                    <div className="row">
                      <CurrentStatusWidget stockvalue={this.state.stockvalue} purchases={this.state.purchases} />
                    </div>
                  </NeedsClaim>

                  <div className="row">
                    <NotificationWidget />
                    <TodoWidget />
                  </div>
                </section>
            </div>
        );
  }

});

export default Dashboard;



// WEBPACK FOOTER //
// ./src/components/dashboard/Dashboard.js